import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/services/app/app.service';
import { CommonService } from 'src/app/services/common/common.service';
import { JobAcceptService } from 'src/app/services/job-accept/job-accept.service';
import { JobService } from 'src/app/services/job/job.service';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';

@Component({
  selector: 'app-rec-confirm-modal',
  templateUrl: './rec-confirm-modal.component.html',
  styleUrls: ['./rec-confirm-modal.component.scss']
})
export class RecConfirmModalComponent {

  public shiftType!:string;
  public textContentObj;
  public dataObj:any;
  public totalShift!:string|number;
  constructor(public dialogRef: MatDialogRef<RecConfirmModalComponent>,@Inject(MAT_DIALOG_DATA) public dialogData:any,private appService:AppService,
  private recruiterService: RecruiterService,
  private jobService:JobService,private commonService:CommonService,private spinner:NgxSpinnerService,private jobAcceptService:JobAcceptService) {}
  
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // this.dataObj=this.textContentObj['delete']

    if(this.dialogData && (this.dialogData.type=='clear' || this.dialogData.type=='copy')){
      
      this.shiftType=this.dialogData.view_type;
      this.textContentObj=this.getTextContentObj()
      this.dataObj=this.textContentObj[this.dialogData.type]
      this.getTotalShift()
    }
    
  }

  onConfirm(){
    if(this.dialogData.type=='shift_request'){
      this.acceptRejectEmp()
    }
    else if(this.dialogData.type=='copy') {
      this.copySchedule()
    }
    else if(this.dialogData.type=='clear'){
      this.clearSchedule()
    }
    else if(this.dialogData.type=='swap_request'){
      this.acceptRejectSwapReq()
    }
  }
  onCancel(){
    this.dialogRef.close()
  }  
  getTextContentObj() {
    return {
      copy: {
        title: `Copy ${this.shiftType}`,
        // title: `Copy ${this.shiftType}`,
        subTitle: `Are you sure you want to copy all shifts scheduled for the previous ${this.shiftType}?`,
        type: "copy",
      },
      clear: {
        title: `Clear  ${this.shiftType}`,
        subTitle: `Are you sure you want to delete every shift scheduled for this ${this.shiftType}? This action is permanent.`,
        type: "clear",
      }
    };
  }

  getShiftLength(){
    let data={}
    this.spinner.show()
    this.jobService.createJob(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.spinner.hide()
          this.appService.downloadFile(success.sheet, 'month')
        }
      },
      error: (error: any) => {
        this.spinner.hide()
        this.commonService.handleError(error);
      },
    });
  }
  acceptRejectEmp(){
    const data=this.dialogData.reqObj
    this.jobAcceptService.acceptRejectJob(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.appService.showToastMessage('success',success.msg)
          this.dialogRef.close({confirm:"yes"})
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }})
  }
  acceptRejectSwapReq(){
    const data=this.dialogData.reqObj
    this.recruiterService.replacementRequestApproveReject(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.appService.showToastMessage('success',success.msg)
          this.dialogRef.close({confirm:"yes"})
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }})
  }
  copySchedule(){
    const data=this.dialogData.reqObj
    this.jobService.copySchedule(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.appService.showToastMessage('success',success.msg)
          this.dialogRef.close({confirm:"yes"})
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }})
  }
  clearSchedule(){
    const data=this.dialogData.reqObj
    this.jobService.deleteShift(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.appService.showToastMessage('success',success.msg)
          this.dialogRef.close({confirm:"yes"})
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }})
  }
  getTotalShift(){
    const data=this.dialogData.totalShift
    this.jobService.totalShift(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
         this.totalShift=success.msg.j_d
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }})
  }
}
